import { render, staticRenderFns } from "./EditarMeusDados.vue?vue&type=template&id=08fd620e&"
import script from "./EditarMeusDados.vue?vue&type=script&lang=js&"
export * from "./EditarMeusDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports